"use strict";
exports.__esModule = true;
var AdminSettingsResponse;
(function (AdminSettingsResponse) {
    var Settings = (function () {
        function Settings() {
        }
        return Settings;
    }());
    AdminSettingsResponse.Settings = Settings;
})(AdminSettingsResponse || (AdminSettingsResponse = {}));
exports.AdminSettingsResponse = AdminSettingsResponse;



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/adminSettings.js
// module id = ../model/dist/models/adminSettings.js
// module chunks = main